export const selectLingoLiftSchoolClassesParamsFromDomObject = (object: HTMLElement) => {
  const isListenwise = JSON.parse(object.dataset?.islistenwise ?? 'false');
  const manageClassesUrl = object.dataset?.manageclassesurl ?? '';
  const currentTeacherId = object.dataset?.currentteacherid ?? '';

  return {
    isListenwise,
    manageClassesUrl,
    currentTeacherId,
  };
};
